@if (processing) {
<div class="grid">
  <div class="col-span-12 center w-full h-full">
    <p-progressSpinner class="flex w-full h-full align-self-center items-center justify-center" />
  </div>
</div>
}
@if (!processing) {
<div class="card">
  <div class="surface-ground px-0 py-8 md:px-6 lg:px-8">
    <div class="flex flex-col gap-4 items-center justify-center mb-12">
      <div class="text-900 font-bold text-6xl mb-4 text-center">I am a&hellip;</div>
      <div class="text-700 text-xl mb-6 text-center line-height-3">Choose which role you'd like to start with. You can
        always add others later!</div>
    </div>
    <div class="bg-surface-50 px-6 py-20 md:px-6 lg:px-8">
      <div class="flex lg:flex-row flex-col gap-8 max-w-7xl mx-auto">
        <div class="w-full flex-1 p-8 flex rounded-2xl flex-col bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
          <div class="flex items-center gap-2">
            <img class="col-fixed pr-3 pb-0 origin-top-right relative"
              src="../../../assets/badges/writer.png" style="right:0px; max-width: 128px;" />
            <div class="col-span-12 md:col pb-0">
              <h4 class="font-medium text-xl mb-2">Writer</h4>
              <p>I'm looking for beta readers</p><br /><br />
            </div>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <div class="flex items-center">
            <span class="font-bold text-2xl">Free</span>
            <span class="ml-2 font-medium"> (always)</span>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <ul class="list-none p-0 m-0 flex-grow-1">
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Submit to the beta-reading project catalogue</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Match with readers interested in your book</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Get feedback on your story</span>
            </li>
          </ul>
          <hr class="mb-3 mx-0 border-top-1 border-none surface-border mt-auto" />
          <button pButton [rounded]="true" class="w-full" (click)="addRoles([PlatformRole.WRITER])">This is me</button>
        </div>
        <div class="w-full flex-1 p-8 flex rounded-2xl flex-col bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
          <div class="flex items-center gap-2">
            <img class="col-fixed pr-3 pb-0 origin-top-right relative absolute"
              src="../../../assets/badges/beta_reader.png" style="right:0px; max-width: 128px;" />
            <div class="col-span-12 md:col pb-0">
              <h4 class="font-medium text-xl mb-2">Beta Reader</h4>
              <p>I'm looking for interesting projects to read</p><br />
            </div>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <div class="flex items-center">
            <span class="font-bold text-2xl">Free</span>
            <span class="ml-2 font-medium"> (always)</span>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <ul class="list-none p-0 m-0 flex-grow-1">
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Find new, free stories to read</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span class="text-900">Match with super-cool projects that interest you</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Filter out stories that aren't your speed</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Tell the writer what you think!</span>
            </li>
          </ul>
          <hr class="mb-3 mx-0 border-top-1 border-none surface-border" />
          <button pButton [rounded]="true" class="w-full" (click)="addRoles([PlatformRole.BETAREADER])">This is
            me</button>
        </div>
        <div class="w-full flex-1 p-8 flex rounded-2xl flex-col bg-surface-0 dark:bg-surface-800 shadow-sm gap-6">
          <div class="flex items-center gap-2">
            <img class="col-fixed pr-3 pb-0 relative absolute" src="../../../assets/badges/superhero.png" style="right:0px; max-width:128px;" />
            <div class="col-span-12 md:col pb-0">
              <h4 class=" font-medium text-xl mb-2">Flippin' Superhero!</h4>
              <p>Sign me up as a writer and a beta reader</p>
            </div>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <div class="flex items-center">
            <span class="font-bold text-2xl">Free</span>
            <span class="ml-2 font-medium"> (always)</span>
          </div>
          <hr class="my-3 mx-0 border-top-1 border-none surface-border" />
          <ul class="list-none p-0 m-0 flex-grow-1">
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Submit to the beta-reading project catalogue</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Match with reading projects that interest you</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>Basically, you get both of the other roles</span>
            </li>
            <li class="flex items-center mb-3">
              <i class="pi pi-check-circle text-green-500 mr-2"></i>
              <span>A superhero badge on your user profile</span>
            </li>
          </ul>
          <hr class="mb-3 mx-0 border-top-1 border-none surface-border" />
          <button pButton [rounded]="true" class="w-full" (click)="addRoles([PlatformRole.WRITER, PlatformRole.BETAREADER])">This is me</button>
        </div>
      </div>
    </div>
  </div>
</div>
}